/**
 * Pablo's account - used for billing and access to Pablo's style
 *
 * TODO: Migrate to caresenddev account
 * Account: carsenddev, Email: dev@caresend.co
 * pk.eyJ1IjoiY2FyZXNlbmRkZXYiLCJhIjoiY203ejlnemM2MGoxdDJpcTNoaGFhYmZpYSJ9.HACkXSmmpHhyy5txqPIsfw
 * Must ensure we can access or transfer all styles first. (Pablo's is currently private)
 */
const MAPBOX_TOKEN = 'pk.eyJ1IjoicGFibG9ndWlkaSIsImEiOiJja2xyeHkybXYxcXowMndtcG55NzFmcWtnIn0.1zv8RUFMyErWshQPRUcKFg';
const MAPBOX_STYLE_DARK = 'mapbox://styles/birolleauf/cklsxs9oa0nu217qaf1hp08m8?optimize=true';
const MAPBOX_STYLE_LIGHT = 'mapbox://styles/pabloguidi/ckt4fraau0l6w18oa8gojov0p';
const MAPBOX_STYLE_LIGHT_EXAS = 'mapbox://styles/caresenddev/cm7z9xssn000q01sl5at5ed5o';

export { MAPBOX_STYLE_DARK, MAPBOX_STYLE_LIGHT, MAPBOX_STYLE_LIGHT_EXAS, MAPBOX_TOKEN };
